import { Platform } from 'react-native';

import { useCommunity } from '@/hooks/useCommunity';

export const useKlipyApiKey = (): string | undefined => {
  const community = useCommunity();
  if (!community?.klipy?.apiKeys) return undefined;

  if (Platform.OS === 'ios') {
    return community.klipy.apiKeys.ios;
  }

  if (Platform.OS === 'android') {
    return community.klipy.apiKeys.android;
  }

  return community.klipy.apiKeys.web;
};
